export function Footer() {
  return (
    <div className="bg-gray-800">
      <div className="font-mono text-white p-3 text-center">
        Brought to you by the Husky Satellite Lab of the University of
        Washington
      </div>
    </div>
  )
}
